import React from 'react';
import styled from 'styled-components';

import {BOTTOM_FRAME, TOP_FRAME} from 'App';

import Rods from '../../Rods';
import Automation, { AdditionalSupport } from '../../Automation';

const Top = styled.div`
  background-image: url('img/gateTilting/top.png');
  background-size: contain;
  width: 100%;
  flex-shrink: 0;
`;

const Bottom = styled.div`
  background-image: url('img/gateTilting/bottom.png');
  background-size: auto;
  width: 100%;
  flex-shrink: 0;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  position: relative;
`;

const Middle = ({ design, scale, projectType }) => (
  <Container>
    <Top style={{ height: `${TOP_FRAME / scale}px` }} />
    <Rods
      design={design}
      scale={scale}
      projectType={projectType}
      fenceType="gateTilting"
    />
    <Bottom style={{ height: `${BOTTOM_FRAME / scale}px` }} />
    {/* <Automation/> */}
    {<AdditionalSupport />}
  </Container>
);

export default Middle;
